<template>
  <ChatTemplate>
    <template v-slot:title>
      <div>#</div>
      <div>{{ tender.tenderNumber }}</div>.
      <div class="ml-1">
        {{ tender.title }}
      </div>
    </template>
    <template v-slot:items>
      <AgreementsHistory
        class="width-70 mx-auto"
        :items="items"
        mode="big"/>
    </template>
  </ChatTemplate>
</template>
<script>
import ChatTemplate from 'components/common/blocks/history/ChatTemplate.vue'
import AgreementsHistory from 'components/agreement/AgreementsHistory.vue'

export default {
  name: 'dialogAgreement',
  props: {
    /**
     * Данные согласовантов
     */
    items: {
      type: Array
    },
    /**
     * Данные тендеров
     */
    tender: {
      type: Object
    },
  },
  components: {
    ChatTemplate,
    AgreementsHistory
  }
}
</script>
